import TYPES from "../constants";
import axios from "axios";
import { BaseUrl } from "../../ApiBaseUrl/ApiBaseUrl";
import { toast } from "react-toastify";
import {
  DELETE_VENDOR_BY_ADMIN,
  GET_APPROVAL_CYCLE,
  GET_APPROVAL_CYCLE_DATA_BY_ID,
  GET_VENDOR_CHANGE_HISTORY,
  JOB_APPROVAL_V2,
  VENDOR_CHANGES_LOG,
} from "../../ApiEndPoints/ApiEndPoints";

//Inital action for calling the DELETE VENDOR API
export const deleteVendorRequest = () => {
  return {
    type: TYPES.DELETE_VENDOR,
  };
};

// Action function for current row data for the delete purpose

export const currentVendorRowData = (row) => {
  return {
    type: TYPES.CURRENT_VENDOR_ROW_DATA,
    payload: row,
  };
};

export const deleteVendor = (vendorData) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch(deleteVendorRequest());
      const response = await axios.get(
        `${BaseUrl}${DELETE_VENDOR_BY_ADMIN}${vendorData?.vendor_id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.status === 200) {
        toast.success(response.data.message);
        dispatch({
          type: TYPES.DELETE_VENDOR_SUCCESS,
          payload: response.data,
        });

        return true;
      } else {
        toast.error(response.data.message);
        dispatch({
          type: TYPES.DELETE_VENDOR_FAILURE,
          error: "Something went wrong , please try again",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.DELETE_VENDOR_FAILURE,
        error: error.message,
      });
      toast.success(error.message);
    }
  };
};

export const getAllVendorLogs = ({ id }) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch({
        type: TYPES.VENDOR_CHANGES_LOG_LOADING,
      });
      const response = await axios.get(
        `${BaseUrl}${VENDOR_CHANGES_LOG}/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_CHANGES_LOG_SUCCESS,
          payload: response.data.data,
        });
      } else {
        dispatch({
          type: TYPES.VENDOR_CHANGES_LOG_FAILURE,
          error: "Something went wrong , please try again",
        });
      }
    } catch (error) {
      dispatch({
        type: TYPES.VENDOR_CHANGES_LOG_FAILURE,
        error: error.message,
      });
    }
  };
};

export const approveAllRequest = (vendorId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch({
        type: TYPES.VENDOR_APPROVE_REQUEST,
      });
      const response = await axios.patch(
        `${BaseUrl}${JOB_APPROVAL_V2}/${vendorId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch({
          type: TYPES.VENDOR_APPROVE_SUCCESS,
          payload: response.data.data,
        });
        return response;
      } else {
        dispatch({
          type: TYPES.VENDOR_APPROVE_FAILURE,
          error: "Something went wrong , please try again",
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
      dispatch({
        type: TYPES.VENDOR_APPROVE_FAILURE,
        error: error.message,
      });
    }
  };
};

export const getVendorEditCycleAction = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch({
        type: TYPES.GET_VENDOR_EDIT_CYCLE_LOADING,
      });
      const response = await axios.get(
        `${BaseUrl}${GET_APPROVAL_CYCLE}${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
      
        dispatch({
          type: TYPES.GET_VENDOR_EDIT_CYCLE_SUCCESS,
          payload: response.data.data,
        });
        return response
      } else {
        dispatch({
          type: TYPES.GET_VENDOR_EDIT_CYCLE_FAILURE,
          error: "Something went wrong , please try again",
        });
        return false
      }
    } catch (error) {
      dispatch({
        type: TYPES.GET_VENDOR_EDIT_CYCLE_FAILURE,
        error: error.message,
      });
    }
  };
};

export const getVendorEditCycleDataByIdAction = (id,vendorId) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch({
        type: TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_LOADING,
      });
      const response = await axios.get(
        `${BaseUrl}${GET_APPROVAL_CYCLE_DATA_BY_ID}${id}/${vendorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
      
        dispatch({
          type: TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_SUCCESS,
          payload: response.data.data,
        });
        return response
      } else {
        dispatch({
          type: TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_FAILURE,
          error: "Something went wrong , please try again",
        });
        return false
      }
    } catch (error) {
      dispatch({
        type: TYPES.GET_VENDOR_EDIT_CYCLE_DATA_BY_ID_FAILURE,
        error: error.message,
      });
    }
  };
};

export const getVendorHistoryExportAction = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem("vms_admin_token");
      dispatch({
        type: TYPES.GET_VENDOR_HISTORY_EXPORT_LOADING,
      });

      let {
        vendorIds,
        startDate,
        endDate
      } = params;

      const qParams = new URLSearchParams({
        vendorIds:JSON.stringify(vendorIds)
      })

      if(startDate && endDate){
        qParams.append("startDate", startDate);
        qParams.append("endDate", endDate);
      }

      const response = await axios.get(
        `${BaseUrl}${GET_VENDOR_CHANGE_HISTORY}${qParams.toString()}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
      
        dispatch({
          type: TYPES.GET_VENDOR_HISTORY_EXPORT_SUCCESS,
          payload: response.data.data,
        });
        return response
      } else {
        dispatch({
          type: TYPES.GET_VENDOR_HISTORY_EXPORT_FAILURE,
          error: "Something went wrong , please try again",
        });
        return false
      }
    } catch (error) {
      dispatch({
        type: TYPES.GET_VENDOR_HISTORY_EXPORT_FAILURE,
        error: error.message,
      });
    }
  };
};